module.exports = __webpack_public_path__ + "img/no-noti.bf0d4228.png";